<template>
  <div>
    <div class="boxs">
      <div class="top">{{ item.storeHouse.name }}</div>
      <div class="content">
        <Row>
          <Col :span="24"><span class="title">仓库类型:</span>{{ item.storeHouse.storeHouseType }}</Col>
        </Row>
        <Row>
          <Col :span="24"><span class="title">负责人:</span>{{ item.storeHouse.personInCharge }}</Col>
        </Row>
        <Row>
          <Col :span="24"><span class="title">电话:</span>{{ item.storeHouse.dutyTelephone }}</Col>
        </Row>
        <Row>
          <Col :span="24"><span class="title">地址:</span>{{ item.storeHouse.address }}</Col>
        </Row>
        <Row>
          <Col :span="24"><span class="title">所属街道:</span>{{ item.streedName }}</Col>
        </Row>
        <Row>
          <Col :span="24"><span class="title">所属地址:</span>{{ item.unitName }}</Col>
        </Row>
        <Row>
          <Col :span="24"><span class="title">仓库简介:</span>{{ item.storeHouse.introduce }}</Col>
        </Row>
      </div>
      <div class="footer"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  name: "WarehouseWindows"
}
</script>

<style scoped lang="less">
.boxs {
  overflow: hidden;

  .top {
    color: #ffffff;
    height: 4vh;
    line-height: 4vh;
    padding-left: .5rem;
    font-size: .7rem;
  }

  .content {
    padding-left: .5rem;
    color: #ffffff;
    font-size: .7rem;
    overflow: auto;
    height: 20vh;
    line-height: 1.4rem;

    &::-webkit-scrollbar {
      display: none;
    }

    .ivu-col {
      line-height: 1.3rem;
      overflow: hidden;
      text-overflow: ellipsis;
      display: inline;
      white-space: nowrap;
    }

    .title {
      color: #72aefa;
    }
  }
}
</style>
